import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  private excludedUrls: string[] = [];

  setLoading(loading: boolean): void {
    this.ngZone.run(() => {
      this.loadingSubject.next(loading);
    });
  }

  setProgress(progress: number): void {
    this.ngZone.run(() => {
      this.progressSubject.next(progress);
    });
  }

  setExcludedUrls(urls: string[]): void {
    this.excludedUrls = urls;
  }

  addExcludedUrl(url: string): void {
    if (!this.excludedUrls.includes(url)) {
      this.excludedUrls.push(url);
    }
  }

  removeExcludedUrl(url: string): void {
    const index = this.excludedUrls.indexOf(url);
    if (index > -1) {
      this.excludedUrls.splice(index, 1);
    }
  }

  isUrlExcluded(url: string): boolean {
    return this.excludedUrls.some(excludedUrl => url.includes(excludedUrl));
  }

  show(): void {
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.loadingSubject.next(false);
  }

  reset(): void {
    this.loadingSubject.next(false);
    this.progressSubject.next(0);
  }
}
